import { useEffect, useRef, useState } from 'react';
import { api, type W2SentenceAnalysisResponse } from '../utils/api';

export function useW2SentenceAnalysis(userId: string | undefined, token: string | null, category: string, bankVersion: string, level: number) {
  const scope = `${userId}:${category}:${bankVersion}:${level}:${token}`;
  const current = useRef(scope);
  current.current = scope;
  const requestId = useRef(0);
  const [state, setState] = useState<{ scope: string; result: W2SentenceAnalysisResponse | null; loading: boolean; error: string }>({
    scope, result: null, loading: false, error: ''
  });
  useEffect(() => () => { requestId.current++; }, [scope]);
  const active = state.scope === scope;
  const result = active ? state.result : null;

  const analyze = async (items: Array<{ question_id: string }>, refresh = false) => {
    if (!token || !userId || bankVersion !== '2.0' || level !== 4 || !items.length) return null;
    const ids = [...new Set(items.map(q => q.question_id))];
    if (!refresh && result && ids.every(id => result.guides.some(guide => guide.question_id === id)) && result.proof.expires_at > Date.now()) return result;
    const sequence = ++requestId.current;
    setState({ scope, result, loading: true, error: '' });
    try {
      const analysis = await api.analyzeAdminUserW2Sentences(userId, token, category, ids);
      if (current.current !== scope || sequence !== requestId.current) return null;
      setState({ scope, result: analysis, loading: false, error: '' });
      return analysis;
    } catch (error: any) {
      if (current.current === scope && sequence === requestId.current) {
        setState({ scope, result, loading: false, error: error?.message || '造句分析失败，请重试。' });
      }
      return null;
    }
  };
  return { result, loading: active && state.loading, error: active ? state.error : '', analyze };
}
